module.exports = require("./../../_gen/starling/styles/DistanceFieldStyle");